<i [ngClass]="iconType() + ' ' + textColour()"></i>
